export const convertToHex = (value: string | number) => `0x${Number(value).toString(16)}`;
